import React from 'react';
import Reveal from '../../reveal';
import RevealEdges from '../../animations/reveal-edges';
import { chunk } from '../../../utils/helper-functions';
import Img from 'gatsby-image';
import ProjectBlurb from '../project-blurb';
import styles from './project-marketing-tiles.module.css';

const ProjectMarketingTiles = props => {
  return (
    <Reveal>
      <ProjectMarketingTilesContent {...props} />
    </Reveal>
  );
};

const ProjectMarketingTilesContent = props => {
  const { images, blurb, wrapperPadding, isInView } = props;
  const renderRows = () => {
    const newTiles = chunk(images, 2);
    return newTiles.map((tiles, index) => {
      return (
        <div
          className={styles.row}
          key={index}
          style={{ position: 'relative' }}
        >
          <RevealEdges isInView={isInView} />
          {renderTiles(newTiles[index])}
        </div>
      );
    });
  };

  const renderTiles = Tiles => {
    return Tiles.map((tile, index) => {
      return (
        <div key={index} className={styles.tile}>
          <Img
            sizes={tile.image.localFile.childImageSharp.sizes}
            backgroundColor={true}
          />
        </div>
      );
    });
  };

  return (
    <div className={styles.wrapper} style={{ padding: wrapperPadding }}>
      {renderRows()}
      <ProjectBlurb blurb={blurb} />
    </div>
  );
};

export default ProjectMarketingTiles;



// WEBPACK FOOTER //
// ./src/components/project/project-marketing-tiles/index.js